import misRtuas from 'vue-routes-generator'
import AnunciantesComponent from './App'

export default {
	install: Vue => {
		misRtuas.route('/main').child('anunciantes', {
			name: 'Gestión de anunciantes',
			component: AnunciantesComponent
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/gestion-anunciantes/vue/index.js